// store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./root-reducer";
import { createWrapper } from "next-redux-wrapper";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // by default serializableCheck set to true by the getDefaultMiddleware middleware
      // which checks the data to be dispatched in serialized form
      // we set it to false as we have non serialized data
      serializableCheck: false,
    }),
});

const makeStore = () => store;

// wrap store with createWrapper for SSR
export const wrapper = createWrapper(makeStore);

export default store;
